import React, { ReactNode } from 'react'
import Stack from '@mui/material/Stack'
import { NestedMultiselectFilterItem } from '../../NestedMultiselectFilter'
import { SearchInput } from '../../SearchInput'
import DataTableFiltersButton from './DataTableFiltersButton'

type DataTableToolbarProps = {
    searchQuery: string
    onSearchQueryChange: (value: string) => void
    searchPlaceholder?: string
    filterItems: NestedMultiselectFilterItem[]
    selectedItemIds: string[]
    onSelectionChange: (selectedItemIds: string[]) => void
    appliedFiltersCount: number
    onResetFilters?: () => void
    canResetFilters?: boolean
    hiddenColumnsCount?: number
    actionsSlot?: ReactNode
    searchWidth?: number
    filterMenuWidth?: number
}

/** Widths taken from the design: the page-level toolbar gets a wide field, nested panels a short one. */
export const DATA_TABLE_SEARCH_WIDTH = 458

export const DATA_TABLE_NESTED_SEARCH_WIDTH = 247

export const DataTableToolbar = ({
    searchQuery,
    onSearchQueryChange,
    searchPlaceholder,
    filterItems,
    selectedItemIds,
    onSelectionChange,
    appliedFiltersCount,
    onResetFilters,
    canResetFilters,
    hiddenColumnsCount,
    actionsSlot,
    searchWidth = DATA_TABLE_SEARCH_WIDTH,
    filterMenuWidth,
}: DataTableToolbarProps) => (
    // Stacks below md: sharing one row squeezed the search field, the only flexible item in it.
    <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent="space-between"
        columnGap={2}
        rowGap={1.5}
        flexWrap="wrap"
    >
        <Stack direction="row" alignItems="center" gap={2} flex={{ xs: 'none', md: 1 }} minWidth={0}>
            <SearchInput
                value={searchQuery}
                onChange={onSearchQueryChange}
                placeholder={searchPlaceholder}
                width={searchWidth}
            />
            {!!filterItems.length && (
                <DataTableFiltersButton
                    items={filterItems}
                    selectedItemIds={selectedItemIds}
                    onSelectionChange={onSelectionChange}
                    appliedFiltersCount={appliedFiltersCount}
                    hiddenColumnsCount={hiddenColumnsCount}
                    onResetFilters={onResetFilters}
                    canResetFilters={canResetFilters}
                    menuWidth={filterMenuWidth}
                />
            )}
        </Stack>
        {!!actionsSlot && (
            <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={1} flexWrap="wrap" flexShrink={0}>
                {actionsSlot}
            </Stack>
        )}
    </Stack>
)

export default DataTableToolbar
